export default "<!-- <div class=\"top-bar\">\n    <app-top-bar></app-top-bar>\n</div> -->\n\n<router-outlet></router-outlet>\n"